<template>
    <PageFrame>
        <div>
            <h1>Terms Of Service</h1>
            <p>Contrary to many sites we try to keep our Terms of Service pretty simple.  In short, by using the site you agree to indemnify Open Source Jobs for anything at all times.  And in the meantime, we make a commitment to provide the very best service we can while delivering the most value possible.  We are not interested in generating revenue at the expense of our reputation or credibility in the marketplace, and never will be.  As a result, we will never deceive or knowingly mislead anyone for any reason.  We want to bring together companies and organizations that need open source skills and experience with human beings possessing one and/or the other, plain and simple.</p>
        </div>
    </PageFrame>
</template>

<script>
    import PageFrame from '@/components/PageFrame.vue'
    export default {
        name: "Tos",
        components : {
            PageFrame
        }
    }
</script>